import moment from 'moment';
import React from 'react';
// Coupon or Voucher follow ups/early bird deadline - Set 3
const TwelveStepWhatsappTemplate = ({ values }) => {
  const {
    client_name,
    conference_short_name,
    registration_link,
    deadline_date,
    your_name,
    contact_details,
  } = values;
  return (
    <div>
      <p>Dear {client_name ? client_name : `[Lead's Name]`},</p>
      <p>
        This is your final opportunity to take advantage of the{' '}
        <strong>exclusive Early Bird discount</strong>{' '}
        <strong>
          {conference_short_name
            ? conference_short_name
            : `[Conference Short Name]`}
        </strong>
        , scheduled to expire on{' '}
        <strong>{deadline_date ? deadline_date : `[Deadline Date]`}</strong>.
      </p>
      <p>
        Don’t miss out on this opportunity to join leading experts, engage in
        groundbreaking discussions, and enhance your professional credentials.
      </p>

      <div>
        <strong>Key Highlights of the Conference:</strong>
        <ul>
          <li>
            <strong>CPD Accreditation:</strong> Earn a globally recognized CPD
            certification.
          </li>
          <li>
            <strong>Publication Opportunities:</strong> Get your work published
            in Scopus, Web of Science, or SCI-indexed journals.
          </li>
          <li>
            <strong>Global Networking:</strong> Connect with top researchers and
            professionals from around the world.
          </li>
          <li>
            <strong>Innovative Sessions:</strong> Participate in sessions
            aligned with the United Nations SDGs and global research trends.
          </li>
        </ul>
      </div>

      <p>
        {registration_link ? (
          <>
            <strong>Register Now: </strong>
            <a
              href={registration_link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {registration_link}
            </a>
          </>
        ) : (
          <strong>Register Now: [Registration Link]</strong>
        )}
      </p>

      <p>
        <strong>Early Bird Deadline: </strong>{' '}
        {deadline_date ? deadline_date : `[Deadline Date]`}
      </p>
      <p>
        If you have any questions or need assistance, please feel free to reach
        out.
      </p>
      <div>
        <strong>Best regards,</strong>
      </div>
      <div>{your_name ? your_name : '[Your Name]'}</div>
      <div>{contact_details ? contact_details : '[Contact details]'}</div>
    </div>
  );
};

export default TwelveStepWhatsappTemplate;
